import { QTooltip } from '../../../QAtoms';
import { QIcon } from '../../../QIcons';
import { SortDirection } from '@tanstack/react-table';
import type { FC } from 'react';
import { chakra } from '@chakra-ui/react';
import { useLibraryTranslation } from '../../../i18n';

export type SortingIconsProps = {
  direction: SortDirection | false;
};

export const SortingIcon: FC<SortingIconsProps> = ({ direction }) => {
  const { t } = useLibraryTranslation();
  const icon = (
    <chakra.span
      visibility={direction === false ? 'hidden' : undefined}
      aria-hidden={direction === false}
      marginLeft="1"
      position="relative"
      top="3px"
    >
      <QIcon
        iconName={direction === 'asc' ? 'ArrowUp' : 'ArrowDown'}
        size="sm"
        color="gray.500"
      />
    </chakra.span>
  );

  return direction === false ? (
    icon
  ) : (
    <QTooltip
      label={direction === 'asc' ? t('table.sortedAsc') : t('table.sortedDesc')}
    >
      {icon}
    </QTooltip>
  );
};
